<template>
  <Head :title="$page.props.app_name + (title ? ' - ' + title : '')">
    <link :href="'/css/structures/' + $page.props.structure + '/app.css'" rel="stylesheet">
    <link :href="'/css/skins/' + ($page.props.skin) + '/app.css'" rel="stylesheet">
  </Head>
  <main class="forgeron-main forgeron-center" :class="{
    'open-left': false,
    'open-right': false,
    }" :style="{ 'background-image': getBackground() }">
    <header class="forgeron-header d-flex justify-content-between align-items-center">
      <slot name="header-main">
        <div class="header-content d-flex align-items-center">
          <Link :href="'/'" class="d-inline-block flex-grow-0 m-1">
            <img :src="$page.props.app_logo" class="app-logo d-none d-sm-block" />
            <img :src="$page.props.favicon_url" class="app-logo d-sm-none ms-1" />
          </Link>
<!--          <button v-if="isCategoryShow(route, routePrefix)" class="btn btn-primary m-2" type="button">{{ $page.props.featuredCategory.title }}</button>-->
          <div class="flex-grow-1 p-2 m-1 d-flex justify-content-center">
            <template v-for="link in $page.props.navigation_menus.header">
              <Link :href="route(link.route, link.params ?? {})">
                <button class="btn btn-primary mx-2 my-0" type="button">{{ link.text }}</button>
              </Link>
            </template>
          </div>
          <div class="flex-grow-0 p-2 m-1 d-flex justify-content-end header-icons">
            <i class="fa-solid fa-circle-chevron-left m-2" @click="back()" style="cursor:pointer"></i>
          </div>
          <div class="menu-icon-container flex-grow-0 px-2" @click="toggleMenuOpen('right')">
            <div class="d-inline-block menu-icon cursor-pointer my-0 mx-2 px-1">
              <i class="fas fa-bars fa-2x"></i>
            </div>
          </div>
        </div>
      </slot>
    </header>
    <div class="forgeron-main-content d-flex align-items-center w-100">
      <div class="forgeron-content-container w-100">
        <div class="toast-container">
          <toasts v-if="toasts || errors" :toasts="getAllToasts(toasts, errors)"></toasts>
        </div>
        <slot />
      </div>
    </div>
    <footer class="forgeron-footer">
      <slot name="footer-main">
        <div class="footer-content d-flex justify-content-end">
          <div class="header-links pt-1">
            <template v-for="link in $page.props.navigation_menus.footer">
              <Link :href="route(link.route, link.params ?? {})">
                <button class="btn btn-tertiary m-2" type="button">{{ link.text }}</button>
              </Link>
            </template>
          </div>
        </div>
      </slot>
    </footer>
  </main>
  <aside id="forgeron-menu" :class="statusClass('right', $page.props.off_canvas_elements?.right)" class="forgeron-aside forgeron-right offcanvas-menu">
    <slot name="aside-right">
      <header class="forgeron-header">
        <slot name="header-right"></slot>
      </header>
      <main class="forgeron-main">
        <slot name="main-right">
          <Navigation :links="$page.props.navigation_menus.aside"></Navigation>
        </slot>
      </main>
      <footer class="row forgeron-footer">
        <slot name="footer-right"></slot>
      </footer>
    </slot>
  </aside>
</template>

<script>
import Navigation from '@/structures/default/components/Navigation';
import Toasts from '@/structures/default/components/Base/Toasts';
import merge from 'lodash/merge';
import { ref } from 'vue';
import { router, Link, Head, usePage } from '@inertiajs/vue3';

export default {
  components: {
    Head,
    Link,
    Navigation,
    Toasts,
  },
  props: {
    background: { type: String, default: () => null },
    navItems: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    title: { type: String, default: null },
  },
  setup(props) {
    if (usePage().props.matomo) {
      const trackPageView = () => {
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
          var u = "//matomo.nordsehen.tv/";
          _paq.push(['setTrackerUrl', u + 'matomo.php']);
          _paq.push(['setSiteId', '1']);
          var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
          g.async = true;
          g.src = u + 'matomo.js';
          s.parentNode.insertBefore(g, s);
        })();
      }

      trackPageView();
    }

    const getAllToasts = (toasts, errors) => {
      let errorToasts = [];
      for (let key in errors) {
        errorToasts.push({
          title: 'Fehler',
          message: errors[key],
          type: 'error',
        });
      }
      return merge(toasts, errorToasts);
    };

    const getBackground = () => {
      return props.background ?? 'none';
    };

    const logout = (event) => {
      event.preventDefault();
      router.post('/logout', {}, { onSuccess: (window.location.href = '/') });
    };

    const elementIsOpen = ref({left: null, right: null});

    const statusClass = (name, settings) => {
      if (settings?.fixed) {
        return settings.open ? 'open' : '';
      }
      if (elementIsOpen.value[name] === null) {
        elementIsOpen.value[name] = settings?.open;
      }

      return elementIsOpen.value[name] ? 'open' : '';
    };

    const toggleMenuOpen = (name) => {
      elementIsOpen.value[name] = !elementIsOpen.value[name];
    };

    // const isCategoryIndex = (route, routePrefix) => {
    //   return route().current() === `${routePrefix}.video-categories.index`;
    // };

    // const isCategoryShow = (route, routePrefix) => {
    //   return route().current() === `${routePrefix}.video-categories.show`;
    // };

    // const isAnotherRoute = (route, routePrefix) => {
    //   return !isCategoryIndex(route, routePrefix) && !isCategoryShow(route, routePrefix);
    // };

    const back = () => {
      window.history.back();
    };

    return {
      back,
      elementIsOpen,
      getAllToasts,
      getBackground,
      logout,
      statusClass,
      toggleMenuOpen,
      // isCategoryIndex,
      // isCategoryShow,
      // isAnotherRoute,
    };
  },
};
</script>
